import React from 'react';

const SvgWithLabels = ({ company, score }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1353.6 348.8">
    <defs>
      <style>
        {`
          .cls-1 {
            font-family: SFPro-Regular, 'SF Pro';
            font-size: 31px;
            font-variation-settings: 'wdth' 100, 'opsz' 28, 'wght' 400;
          }
          .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {
            fill: #fff;
          }
          .cls-2 {
            font-family: SFPro-Medium, 'SF Pro';
            font-variation-settings: 'wdth' 100, 'opsz' 28, 'wght' 510;
            font-weight: 500;
          }
          .cls-2, .cls-4 {
            font-size: 25px;
          }
          .cls-6 {
            fill: #44adff;
          }
          .cls-6, .cls-7, .cls-8, .cls-9 {
            stroke: #fff;
          }
          .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {
            stroke-miterlimit: 10;
          }
          .cls-7 {
            fill: #007aff;
          }
          .cls-8 {
            fill: #084891;
          }
          .cls-4, .cls-5 {
            font-family: SFPro-Bold, 'SF Pro';
            font-variation-settings: 'wdth' 100, 'opsz' 28, 'wght' 700;
            font-weight: 700;
          }
          .cls-5 {
            font-size: 28.71px;
          }
          .cls-9 {
            fill: #0994ff;
          }
          .cls-10 {
            fill: none;
            stroke: #f2f2f2;
            stroke-dasharray: 4 4;
          }
        `}
      </style>
    </defs>

    {/* Boxes */}
    <rect className="cls-6" x="128.56" y="20.05" width="273.32" height="112.94" />
    <rect className="cls-7" x="401.88" y="20.05" width="273.32" height="112.94" />
    <rect className="cls-9" x="675.2" y="20.05" width="273.32" height="112.94" />
    <rect className="cls-8" x="948.52" y="20.05" width="273.32" height="112.94" />

    {/* Labels */}
    <text className="cls-1" transform="translate(212.34 84.97)">Outpost</text>
    <text className="cls-1" transform="translate(487.22 87.44)">Satellite</text>
    <text className="cls-1" transform="translate(727.11 87.44)">Portfolio Hub</text>
    <text className="cls-1" transform="translate(958.01 87.44)">Transformation Hub</text>

    {/* Dotted line arrow */}
    <line className="cls-10" x1="675.2" y1="227.39" x2="675.2" y2="171.58" />
    <polygon className="cls-3" points="666.53 227.92 675.2 239.48 683.87 227.92 666.53 227.92" />

    {/* Step Numbers */}
    <text className="cls-5" transform="translate(121.49 162.07)">1</text>
    <text className="cls-5" transform="translate(393.23 162.07)">2</text>
    <text className="cls-5" transform="translate(666.16 162.07)">3</text>
    <text className="cls-5" transform="translate(939.22 162.07)">4</text>
    <text className="cls-5" transform="translate(1212.86 162.07)">5</text>

    {/* Dynamic Company and Score */}
    <text class="cls-4" transform="translate(584.34 282.33)">
      <tspan x="60" y="0">{company}</tspan>
    </text>
    <text class="cls-2" transform="translate(631.44 319.18)">
      <tspan x="-10" y="0">Maturity Index: {score}</tspan>
    </text>
  </svg>
);

export default SvgWithLabels;
